/**
 * Client-side JavaScript: Console/Log Rendering.
 * Renders browser console logs (E2E) and terminal logs (API) in the drawer.
 */

export const JS_CONSOLE = `
  /* ── Console Log Level Colors & Labels ── */
  var LOG_COLORS={log:'#9ca3af',warn:'#fbbf24',error:'#f87171',info:'#60a5fa',debug:'#a78bfa',stdout:'#9ca3af',stderr:'#f87171'};
  var LOG_LABELS={log:'LOG',warn:'WARN',error:'ERR',info:'INFO',debug:'DBG',stdout:'OUT',stderr:'ERR'};

  function consoleVideoOffset(entry,baseTime){
    if(!baseTime||!entry.timestamp)return -1;
    var t=Date.parse(entry.timestamp);
    if(isNaN(t))return -1;
    var off=(t-baseTime)/1000;
    return off>=0?off:-1;
  }

  function renderConsoleLogEntry(entry,hasVideo,baseTime){
    var off=hasVideo?consoleVideoOffset(entry,baseTime):-1;
    var seekable=off>=0;
    var h='<div class="console-entry console-level-'+esc(entry.level)+(seekable?' seekable':'')+'" data-console-level="'+esc(entry.level)+'"'+(seekable?' data-offset="'+off.toFixed(2)+'"':'')+'>';
    h+='<span class="console-level-badge" style="color:'+LOG_COLORS[entry.level]+'">'+LOG_LABELS[entry.level]+'</span>';
    if(seekable){h+='<span class="console-offset">'+off.toFixed(1)+'s</span>';}
    else{h+='<span class="console-time">'+fmtDate(entry.timestamp).split(', ').pop()+'</span>';}
    h+='<span class="console-text">'+esc(stripAnsi(entry.text))+'</span>';
    if(entry.location){var short=entry.location.split('/').pop()||entry.location;h+='<span class="console-loc" title="'+esc(entry.location)+'">'+esc(short)+'</span>';}
    h+='</div>';
    return h;
  }

  var CON_ROW_H=24;
  var CON_VBUF=40;

  function renderConsoleColumn(logs,testType,hasVideo,baseTime){
    if(!logs||logs.length===0)return '';
    var isApi=testType==='api';
    var label=isApi?'Terminal Logs':'Console';

    var counts={};
    for(var i=0;i<logs.length;i++){var l=logs[i].level;counts[l]=(counts[l]||0)+1;}

    var uid='clog-'+Math.random().toString(36).substr(2,6);
    var h='<div class="console-panel" id="'+uid+'">';
    h+='<div class="console-header">';
    h+='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="4 17 10 11 4 5"/><line x1="12" y1="19" x2="20" y2="19"/></svg>';
    h+=' '+label+' <span class="console-count">'+logs.length+'</span>';
    if(counts.error||counts.stderr){var ec=(counts.error||0)+(counts.stderr||0);h+=' <span class="console-error-count">'+ec+' error'+(ec>1?'s':'')+'</span>';}
    if(counts.warn)h+=' <span class="console-warn-count">'+counts.warn+' warning'+(counts.warn>1?'s':'')+'</span>';
    h+='</div>';

    h+='<div class="console-toolbar">';
    h+='<button class="console-filter-btn active" data-console-filter="all">All</button>';
    var levels=isApi?['stdout','stderr']:['log','info','warn','error','debug'];
    for(var li=0;li<levels.length;li++){
      var lv=levels[li];
      if(counts[lv])h+='<button class="console-filter-btn" data-console-filter="'+lv+'">'+LOG_LABELS[lv]+' <span style="opacity:.6">'+counts[lv]+'</span></button>';
    }
    h+='</div>';

    /* Pre-compute video offsets for all entries */
    var videoOffsets=[];
    if(hasVideo&&baseTime){
      for(var oi=0;oi<logs.length;oi++){videoOffsets.push(consoleVideoOffset(logs[oi],baseTime));}
    }

    /* Use virtualization for large log lists */
    if(logs.length>200){
      h+='<div class="console-list console-vlist" style="overflow-y:auto;max-height:400px;position:relative">';
      h+='<div class="console-vspacer" style="height:'+(logs.length*CON_ROW_H)+'px;position:relative"></div>';
      h+='</div>';
      h+='</div>';

      setTimeout(function(){
        var panel=document.getElementById(uid);if(!panel)return;
        var list=panel.querySelector('.console-vlist');if(!list)return;
        var spacer=list.querySelector('.console-vspacer');
        var allLogs=logs;
        var filteredIdxs=null;
        var highlightIdx=-1;

        function getVis(){return filteredIdxs||allLogs.map(function(_,i){return i});}

        function paint(){
          var vis=getVis();
          spacer.style.height=(vis.length*CON_ROW_H)+'px';
          var st=list.scrollTop;var vh=list.clientHeight;
          var s0=Math.max(0,Math.floor(st/CON_ROW_H)-CON_VBUF);
          var s1=Math.min(vis.length,Math.ceil((st+vh)/CON_ROW_H)+CON_VBUF);
          var out='';
          for(var vi=s0;vi<s1;vi++){
            var ri=vis[vi];var entry=allLogs[ri];
            var off=videoOffsets[ri];
            var seekable=off>=0;
            var isActive=ri===highlightIdx;
            out+='<div class="console-entry console-level-'+esc(entry.level)+(seekable?' seekable':'')+(isActive?' console-active':'')+'" data-console-level="'+esc(entry.level)+'"'+(seekable?' data-offset="'+off.toFixed(2)+'"':'')+' data-vidx="'+ri+'" style="position:absolute;top:'+(vi*CON_ROW_H)+'px;left:0;right:0;height:'+CON_ROW_H+'px">';
            out+='<span class="console-level-badge" style="color:'+LOG_COLORS[entry.level]+'">'+LOG_LABELS[entry.level]+'</span>';
            if(seekable){out+='<span class="console-offset">'+off.toFixed(1)+'s</span>';}
            else{out+='<span class="console-time">'+fmtDate(entry.timestamp).split(', ').pop()+'</span>';}
            out+='<span class="console-text">'+esc(stripAnsi(entry.text))+'</span>';
            if(entry.location){var short=entry.location.split('/').pop()||entry.location;out+='<span class="console-loc" title="'+esc(entry.location)+'">'+esc(short)+'</span>';}
            out+='</div>';
          }
          spacer.innerHTML=out;
        }

        var rafP=false;
        list.addEventListener('scroll',function(){if(!rafP){rafP=true;requestAnimationFrame(function(){rafP=false;paint();})}},{passive:true});

        /* Click-to-seek for virtual entries */
        list.addEventListener('click',function(e){
          var entry=e.target.closest('.console-entry.seekable');
          if(!entry)return;
          var off=parseFloat(entry.getAttribute('data-offset'));
          if(isNaN(off))return;
          var video=document.querySelector('.drawer-body video');
          if(video){video.currentTime=off;video.play();}
        });

        /* Store filter handler */
        panel.__conFilter=function(level){
          if(!level||level==='all'){filteredIdxs=null;}
          else{filteredIdxs=[];for(var i=0;i<allLogs.length;i++){if(allLogs[i].level===level)filteredIdxs.push(i);}}
          list.scrollTop=0;paint();
        };

        /* Video sync: scroll to matching entry by time */
        panel.__videoSync=function(seconds){
          if(!videoOffsets.length)return;
          var vis=getVis();
          var matchVi=-1;
          for(var i=vis.length-1;i>=0;i--){
            if(videoOffsets[vis[i]]>=0&&videoOffsets[vis[i]]<=seconds){matchVi=i;break;}
          }
          if(matchVi<0){highlightIdx=-1;paint();return;}
          var newHL=vis[matchVi];
          if(newHL===highlightIdx)return;
          highlightIdx=newHL;
          /* Scroll to row */
          var rowTop=matchVi*CON_ROW_H;
          var vh=list.clientHeight;
          if(rowTop<list.scrollTop||rowTop>list.scrollTop+vh-CON_ROW_H){
            list.scrollTop=rowTop-vh/2;
          }
          paint();
        };

        paint();
      },0);
    }else{
      h+='<div class="console-list">';
      for(var i=0;i<logs.length;i++){h+=renderConsoleLogEntry(logs[i],hasVideo,baseTime);}
      h+='</div>';
      h+='</div>';

      /* Wire up click-to-seek for non-virtual entries */
      if(hasVideo&&baseTime){
        setTimeout(function(){
          var panel=document.getElementById(uid);if(!panel)return;
          panel.addEventListener('click',function(e){
            var entry=e.target.closest('.console-entry.seekable');
            if(!entry)return;
            var off=parseFloat(entry.getAttribute('data-offset'));
            if(isNaN(off))return;
            var video=document.querySelector('.drawer-body video');
            if(video){video.currentTime=off;video.play();}
          });
          /* Video sync for non-virtual */
          var entries=panel.querySelectorAll('.console-entry.seekable');
          var offsets=[];
          for(var i=0;i<entries.length;i++){
            var off=parseFloat(entries[i].getAttribute('data-offset'));
            if(!isNaN(off))offsets.push({el:entries[i],offset:off});
          }
          if(offsets.length){
            var lastHL=null;
            panel.__videoSync=function(seconds){
              var match=null;
              for(var i=offsets.length-1;i>=0;i--){
                if(offsets[i].offset<=seconds){match=offsets[i].el;break;}
              }
              if(match===lastHL)return;
              if(lastHL)lastHL.classList.remove('console-active');
              if(match){match.classList.add('console-active');match.scrollIntoView({block:'nearest',behavior:'smooth'});}
              lastHL=match;
            };
          }
        },0);
      }
    }
    return h;
  }
`;
